<div class="form-group">
    <!-- <label></label> 
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">
          <label class="m-radio m-radio--single m-radio--state m-radio--state-success">
            <input type="radio" name="radio">
            <span></span>
          </label>
        </span>
      </div>
    </div> -->

    <label class="m-radio m-radio--state-brand">
        <input type="radio" name="radio">
        {{ attribute.key }}
        <!-- <span></span> -->
      </label>

  </div>